export const getModalRootElement = () => {
  if (process.env.NODE_ENV === 'test') {
    return document.createElement('div');
  }
  return document.getElementById('modal-root');
};
